import { ChevronUpDownIcon } from "@heroicons/react/20/solid";

const NewPendingOfferStudentCard = ({newEvent, setNewOfferObject, setFamilySearchOpen, setSomethingWasChanged}) => {

    const calculateAge = (birthday) => { // birthday is a date
        let fixedBDay = new Date(birthday)
         let ageDifMs = Date.now() - fixedBDay.getTime();
         let ageDate = new Date(ageDifMs); // miliseconds from epoch
         if(isNaN(Math.abs(ageDate.getUTCFullYear() - 1970))) {
          return 'Unknown '
         } else {
          return Math.abs(ageDate.getUTCFullYear() - 1970);
         }
      }

      const removeStudent = () => {
        setNewOfferObject((prev) => ({...prev, familyId: '', familyName: '', familyAddress: {}, studentId: '', familyPhoneNumber: '', studentDOB: '', parentName: '', studentName: '', waveCustomerId: '', familyEmail: ''}))
      }

      const openTheSearch = () => {
        setSomethingWasChanged(true)
        setFamilySearchOpen(true)
      }

    return (
        <div className='p-2 border-solid border-gray-300 border rounded-md shadow-sm mt-4'>
        {newEvent.familyId === '' 
        ? 
        <div className="text-left relative" onClick={() => openTheSearch()}>
          <div className='text-black text-sm inline-block py-0 px-3 rounded-md cursor-pointer'>Select Student</div>
          <span className='right-0 absolute'>
            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </span>
        </div> 
        :
        <div>
          <div className='text-right'>
            <div onClick={() => removeStudent()} className='inline-block cursor-pointer text-center align-top font-sm text-xs text-gray-400 hover:text-gray-500 hover:text-white'>remove</div>
          </div>
          <div className='mt-3'>
            <label htmlFor="project-name" className="text-sm w-16 font-medium text-gray-500 inline-block">
              Student:
            </label>
            <div className='text-left pl-1 -mt-5 inline-block'>
              {newEvent && <div className=' font-bold'>{newEvent.studentName} {newEvent.familyName}</div>}
            </div>
          </div>
          <div className='mt-3'>
            <label htmlFor="project-name" className="inline-block text-sm mt-3 w-16 font-medium text-gray-500">
              Age:
            </label>
            <div className='inline-block ml-1'>
            {calculateAge(newEvent.studentDOB)} yrs old
            </div>
          </div>
          <div className='mt-3'>
          <label htmlFor="project-name" className="inline-block align-top text-sm mt-3 w-16 font-medium text-gray-500">
            Address:
          </label>
          <div className='text-left inline-block pl-5 mt-0'>
            {newEvent && <div className=' text-sm pl-0 mt-1'>{newEvent.familyAddress.addressLine1}</div>}
            {newEvent && <div className=' text-sm pl-0'>{newEvent.familyAddress.city}, {newEvent.familyAddress.state}</div>}
            {newEvent && <div className=' text-sm pl-0'>{newEvent.familyAddress.zipcode}</div>}
          </div>
          </div>
          <div>
          <div className='mt-3'>
            <label htmlFor="project-name" className="inline-block text-sm mt-3 w-16 font-medium text-gray-500">
              Parent
            </label>
            <div className='text-left pl-5 inline-block'>
              {newEvent && <div className=' font-bold'>{newEvent.parentName} {newEvent.familyName}</div>}
            </div>
          </div>
          <div className='mt-3'>
            <label htmlFor="project-name" className="inline-block text-sm mt-3 w-16 font-medium text-gray-500">
              Phone Number:
            </label>
            <div className='text-left pl-5 inline-block'>
              {newEvent && <div className=' font-bold'>{newEvent.familyPhoneNumber}</div>}
            </div>
          </div>
          <div className='mt-3'>
            <label htmlFor="project-name" className="inline-block text-sm mt-3 w-16 font-medium text-gray-500">
              Email:
            </label>
            <div className='text-left pl-5 inline-block'>
              {newEvent && <div className=' font-bold'>{newEvent.familyEmail}</div>}
            </div>
          </div>
        </div>
        </div>
        }
      </div>
    )
}
export default NewPendingOfferStudentCard